import { useCallback } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { PERMISSION_SCOPES } from '../constants/permissionResources';
import { selectResourcePermissions } from '../utility/permissionHelper';

const usePermissions = (resource, agencyId = PERMISSION_SCOPES.ANY) => {
  const { group, name, type } = resource;
  const selector = useCallback(
    (state) => selectResourcePermissions(state.permissions, { group, name, type }, agencyId),
    [group, name, type, agencyId]
  );
  return useSelector(selector, shallowEqual);
};

export default usePermissions;
